import Auth from 'utils/auth';

// Component

const AllowAccess = ({ permission: role, children }) => {
  if (Auth.isLoggedIn && Auth.isPermissioned(role)) {
    return children;
  } else {
    return null;
  }
};

export default AllowAccess;



// WEBPACK FOOTER //
// ./src/utils/allowAccess.js